export enum LayoutThemeEnum {
    Light = 'theme-light',
    Dark = 'theme-dark'
}
